import React from 'react';
import { ReactComponent as Logo } from 'assets/images/logo-gray.svg';
import EmptyImage from 'assets/images/new-vault-card-background.png';
import styles from './vault-card.module.scss';

export interface VaultCardProps {
  image: any;
  name: string;
  subtitle: string;
}

const VaultCard: React.FC<VaultCardProps> = ({ image, name, subtitle }) => (
  <div className={styles.vaultCard}>
    <img alt="vault-cover" src={image || EmptyImage} className={styles.image} />
    <Logo width={40} height={40} />
    <h2 className="text__heading4__textNeutral50">{name}</h2>
    <p className="text__body__semi__bold__medium__textNeutral50">{subtitle}</p>
  </div>
);

export { VaultCard };
